import { pullAllBy, find } from 'lodash';

class StartTimesController {
  constructor($rootScope, $state, $scope, eventsService, messageService) {
      this.$rootScope = $rootScope;
      this.$state = $state;
      this.$scope = $scope;
      this.eventsService = eventsService;
      this.messageService = messageService;
  }

  $onInit(){
     this.source.days = this.source.days || [];
     this.times = this.source.times || [];
     let timegap = 60/this.$rootScope.currentProperty.start_time_interval;
     this.timegaps = [ '00:00' ];
     for (let i = 1; i<timegap; i++){
         this.timegaps.push(this.$rootScope.currentProperty.start_time_interval*i + ':00');
     }
     this.timerange = [];

     let starttime = this.$rootScope.currentProperty.property_day_start.split(':')[0];
     let endtime = this.$rootScope.currentProperty.property_day_end.split(':')[0];

     for (let i = starttime; i<endtime; i++){
        let time = i.toString().padStart(2, '0');
        this.timerange.push(time);
     }

     if (this.source.event_days){
        this.transformDays(this.source);
     }
     this.toggles = [];
  }

  onSave() {
    return this.eventsService.updateTimes(this.source, this.times)
      .then(() => {
        switch(this.source.type_name){
            case 'SpaDay':
                this.messageService.success(`The start times for <strong>${this.source.name}</strong> were successfully updated!`, [`app.admin.day-edit({ 'day' : ${this.source.id}})`, `Spa Day`]);
                this.$state.go('app.admin.days');
                break;
            case 'Treatment':
                this.messageService.success(`The start times for <strong>${this.source.name}</strong> were successfully updated!`, [`app.admin.treatment-edit({ 'treatment' : ${this.source.id}})`, `Treatment`]);
                this.$state.go('app.admin.treatments');
                break;
        }
      })
      .catch(() => {
        this.messageService.failure(`The start times could not be successfully updated!`);
      });
  }

  addDay(day){
    if (!this.checkDay(day)){
      this.source.days.push({'day': day.toString()});
    }else{
      pullAllBy(this.source.days, [{'day': day.toString()}], 'day');
    }
  }

  activeday(day){
     return find(this.source.days, {'day': day.toString()});
  }

  activeTime(day, time){
    if (this.activeday(day) && day in this.times){
        if (this.times[day].indexOf(time) > -1){
            return true;
        }else{
            return false;
        }
    }
  }

  activeToggle(time){
    return this.toggles.indexOf(time) > -1;
  }

  toggleTime(day, time){
    if (this.activeday(day)){
        if (!(day in this.times)) this.times[day] = [];
        let current = this.times[day].indexOf(time);
        if (current > -1 ){
            this.times[day].splice(current, 1);
        }else{
            if (!this.activeTime(day, time)) this.times[day].push(time);
        }
    }
  }

  massToggleTime(time){
    let toggled = this.toggles.indexOf(time);
    if (toggled === -1){
        for (let day of this.source.days){
            if (!(day.day in this.times)) this.times[day.day] = [];
            if (!this.activeTime(day.day, time)) this.times[day.day].push(time);
        }
        this.toggles.push(time);
    } else {
        for (let day of this.source.days){
            if (!(day.day in this.times)) this.times[day.day] = [];
            let current = this.times[day.day].indexOf(time);
            this.times[day.day].splice(current, 1);
        }
        this.toggles.splice(toggled, 1);
    }
  }

  finalTime() {
    return (Number(this.timerange.slice(-1)[0])+1) + ':00:00';
  }

  validateTime(day, time = null){
    if (this.timeRange){
        if (this.timeRange.hasOwnProperty(day)){
            if (time){
                if (this.timeRange[day] && this.timeRange[day].start){
                    if (time < this.timeRange[day].start){
                        return false;
                    }
                }
                if (this.timeRange[day] && this.timeRange[day].end){
                    if (time > this.timeRange[day].end){
                        return false;
                    }
                }
            }
            return true;
        }else {
            return false;
        }
    }else{
        return true;
    }
  }

  reformatDay(date){
      if (date.format){
          let day = parseInt(date.format('d'));
          return (day === 0 ? 6 : day-1);
      }
      return date;
  }

  checkDay(day){
    if (!find(this.source.days, {'day': day.toString()})){
        return false;
    }else{
        return true;
    }
  }

  transformDays(availability){
    availability.days = [];
    availability.times = {};
    for (let day of availability.event_days){
      availability.days.push(day);
      for (let times of day.event_start_times){
        if (!availability.times[day.day]) availability.times[day.day] = [];
        availability.times[day.day].push(times.start);
      }
    }

    delete availability.event_days;
    return availability;
  }
}

StartTimesController.$inject = [ '$rootScope', '$state', '$scope', 'eventsService', 'messageService' ];

export default StartTimesController;


// WEBPACK FOOTER //
// ./frontend/admin/app/modules/event/controllers/start.times.controller.js